import labels from "./employeeRecordLabels.json";

// Only presentation lives here. Allowed values and permissions remain server-owned.
export const EMPLOYEE_RECORD_LABELS: Record<string, Record<string, Record<string, string>>> = labels;
export function recordOptions(kind: string, field: string): [string, string][] {
  return Object.entries(EMPLOYEE_RECORD_LABELS[kind]?.[field] ?? {});
}

export interface CatalogueLabel { id: string; name: string }
export function catalogueLabel(code: string | null | undefined, name?: string | null, catalogue: readonly CatalogueLabel[] = []): string | null {
  return name || catalogue.find((item) => item.id === code)?.name || code || null;
}

const countries = new Intl.DisplayNames(["hr"], { type: "region", fallback: "code" });
export function countryLabel(code: string | null | undefined): string | null {
  if (!code) return null;
  // Unknown/malformed identifiers stay visible; never guess from free text.
  if (!/^[A-Z]{2}$/.test(code) || code === "ZZ") return code;
  return countries.of(code) || code;
}

/** The same resolver is used by the archive projection, rows and inbox options. */
export function recordLabel(kind: string, field: string, code: string | null | undefined, resolvedName?: string | null): string | null {
  if (code == null || code === "") return null;
  if (["zemlja_iso2", "zemlja_izdavanja_iso2"].includes(field)) return countryLabel(code);
  return EMPLOYEE_RECORD_LABELS[kind]?.[field]?.[code] ?? catalogueLabel(code, resolvedName);
}
